import { createContext } from 'react';

export const context: any = createContext(null);

export const { Provider, Consumer } = createContext(null);